<template>
  <div class="page-topbar">
    <div class="server-box">
      <span class="server-label">服务器</span>
      <el-radio-group
        :model-value="serverName"
        class="server-group"
        @update:model-value="emit('update:serverName', $event)"
      >
        <el-radio-button value="CN Server">CN</el-radio-button>
        <el-radio-button value="US Server">US</el-radio-button>
        <el-radio-button value="Local Server">本地</el-radio-button>
      </el-radio-group>
      <div class="server-current-card" :class="serverToneClass">
        <div class="server-current-top">
          <span class="server-current-label">当前环境</span>
          <strong>{{ serverName }}</strong>
        </div>
        <div class="server-current-desc">{{ serverEnvDesc }}</div>
      </div>
    </div>

    <div class="page-title-box">
      <div class="page-title">MAZDA 综合维护</div>
      <div class="page-subtitle">文件、数据、版本与账号统一管理</div>
      <div class="page-badges">
        <span class="page-badge">SQL：mazda_db</span>
        <span class="page-badge">Redis：DB1</span>
        <span class="page-badge">{{ serverName }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  serverName: { type: String, required: true },
  serverToneClass: { type: String, default: '' },
  serverEnvDesc: { type: String, default: '' },
});

const emit = defineEmits(['update:serverName']);
</script>

<style scoped>
.page-topbar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
}

.server-box {
  width: 260px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(223, 230, 239, 0.95);
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(23, 43, 77, 0.06);
  backdrop-filter: blur(8px);
}

.server-label {
  font-size: 13px;
  color: #8a94a6;
  letter-spacing: 0.5px;
}

.server-group {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.server-group :deep(.el-radio-button) {
  min-width: 0;
}

.server-group :deep(.el-radio-button__inner) {
  width: 100%;
  min-height: 34px;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #4b5565;
  background: #ffffff;
  border: 1px solid #d9e1ec !important;
  border-left: 1px solid #d9e1ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.server-group :deep(.el-radio-button:first-child .el-radio-button__inner),
.server-group :deep(.el-radio-button:last-child .el-radio-button__inner) {
  border-radius: 8px !important;
}

.server-group :deep(.el-radio-button:not(:first-child) .el-radio-button__inner) {
  margin-left: 0 !important;
}

.server-group :deep(.el-radio-button__inner:hover) {
  color: #2f3a4a;
  border-color: #b8c6d8 !important;
}

.server-group :deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
  color: #ffffff;
  background: linear-gradient(135deg, #4f9cff 0%, #3a8cff 100%);
  border-color: #3a8cff !important;
  border-left-color: #3a8cff !important;
}

.server-group :deep(.el-radio-button__original-radio:focus-visible + .el-radio-button__inner) {
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.18) !important;
}

.server-current-card {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(223, 230, 239, 0.95);
  background: linear-gradient(180deg, #f8fbff, #f3f7ff);
}

.server-current-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.server-current-label {
  font-size: 12px;
  color: #8a94a6;
}

.server-current-top strong {
  font-size: 13px;
  color: #1f2d3d;
}

.server-current-desc {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #5f6b7a;
}

.server-current-card.server-tone-cn {
  background: linear-gradient(180deg, rgba(103, 194, 58, 0.12), rgba(247, 255, 244, 0.96));
  border-color: rgba(103, 194, 58, 0.18);
}

.server-current-card.server-tone-us {
  background: linear-gradient(180deg, rgba(230, 162, 60, 0.14), rgba(255, 249, 240, 0.96));
  border-color: rgba(230, 162, 60, 0.2);
}

.server-current-card.server-tone-local {
  background: linear-gradient(180deg, rgba(144, 147, 153, 0.12), rgba(248, 249, 250, 0.98));
  border-color: rgba(144, 147, 153, 0.18);
}

.page-title-box {
  position: relative;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  padding: 16px 18px;
  border-radius: 14px;
  border: 1px solid rgba(225, 232, 242, 0.95);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(244, 248, 255, 0.94));
  box-shadow: 0 8px 20px rgba(31, 56, 88, 0.07);
}

.page-title,
.page-subtitle,
.page-badges {
  position: relative;
  z-index: 1;
}

.page-title {
  font-size: 22px;
  line-height: 1.2;
  font-weight: 800;
  color: #1f2d3d;
  letter-spacing: 0;
}

.page-subtitle {
  margin-top: 6px;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.page-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.page-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 8px;
  background: rgba(64, 158, 255, 0.1);
  color: #2f6fd6;
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 1180px) {
  .page-topbar {
    flex-direction: column;
    align-items: stretch;
  }

  .server-box {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 20px;
  }
}
</style>
